(function(){try{
/* Daily Ritual mobile rebuilt (2026-08-19 v10): v9 applied the F=0.287 origin-drift growth formula to every slide, derived from pixel-measuring image1's growth across the user's first 20 real iPhone screenshots (width 11.2%->74.3% while left drifted 44.1%->20.3%). The user then sent 15 more real screenshots covering image2 and image3 actually growing in (not just image1) -- re-measuring those with a more rigorous per-row edge-detection (longest contiguous solid-color run per scanline, clustered across rows, immune to caption-text contamination) showed image2 and image3 do NOT drift at all: across 5 clean samples each (widths 50.4%->75.1% for image2, 55.1%->75.6% for image3) the left edge stayed pinned at 19.8% the entire time. Re-measuring image1's original 5 points with this same stricter method reproduced the exact same drifting numbers as before, confirming image1 really is the odd one out. So: only slide index 0 gets the origin-drift growth formula (it has no predecessor already occupying the anchored box, so it grows in from a smaller, more-centred seed); every other slide grows the same way it recedes -- pure width scale with left pinned at LEFT=19.8vw throughout. Recede (once superseded by the next slide) remains unchanged and independently confirmed again this round: width floors at ~45.5vw actual vs 45.6vw predicted (76*(1-0.4)), left fixed at 19.8 the whole time. Caption position still tracks the image's live rendered height each frame (top fixed at 0, height follows width via aspect-ratio). */
function rzmInit(){try{
var wrap=document.getElementById('rzm-wrap');if(!wrap)return;
var blocks=[].slice.call(wrap.querySelectorAll('.rzm-block'));
var N=blocks.length;if(!N)return;
var imgboxes=blocks.map(function(b){return b.querySelector('.rzm-imgbox');});
var rows=blocks.map(function(b){return b.querySelector('.rzm-row');});
var LEFT=19.8,LARGE=76,F=0.287; // vw / origin fraction -- see measurement note above
if(!window.gsap||!window.ScrollTrigger){
imgboxes.forEach(function(box){box.style.left=LEFT+'vw';box.style.width=LARGE+'vw';});
rows.forEach(function(row,i){row.style.opacity='1';row.style.top=(imgboxes[i].offsetHeight+20)+'px';});
return;
}
gsap.registerPlugin(ScrollTrigger);
var FAST_IN=1.5; // jobyaviation.com --fast-in
var progressIn=new Array(N).fill(0);
function shorted(v,mult){return Math.min(v*mult,1);}
function clamp01(v){return Math.max(0,Math.min(1,v));}
function render(){
for(var i=0;i<N;i++){
var pIn=progressIn[i];
var pOut=(i+1<N)?progressIn[i+1]:0;
var sIn=shorted(pIn,FAST_IN);
var left=(i===0)?(LEFT+(1-sIn)*F*LARGE):LEFT; // only slide 0 drifts in from the origin fraction -- see measurement note above
var width=LARGE*sIn*(1-pOut*0.4);
imgboxes[i].style.left=left.toFixed(2)+'vw';
imgboxes[i].style.width=width.toFixed(2)+'vw';
var hPx=imgboxes[i].offsetHeight;
rows[i].style.top=(hPx+20)+'px';
var fadeIn=clamp01((pIn-0.6)/0.1);
var fadeOut=1-clamp01(pOut/0.1);
rows[i].style.opacity=(fadeIn*fadeOut).toFixed(3);
}
}
blocks.forEach(function(block,i){
ScrollTrigger.create({
trigger:block,start:'top 100%',end:'top -50%',scrub:true,invalidateOnRefresh:true,
onUpdate:function(self){progressIn[i]=self.progress;render();}
});
});
render();
}catch(e){}}
if(window.innerWidth<900){rzmInit();return;}
/* Desktop Daily Ritual, replaced (2026-08-18): the old two-lane drift marquee
   is gone -- direct instruction to replace the whole desktop section with the
   hero+corner-zoom scrub concept (jobyaviation.com-style SectionApp pattern).
   3 rituals (coffee/carrots/creme brulee, indices 0-2) cycle through a large
   hero + small corner preview as the section pins and scrubs; a 4th card
   (honey, index 3) is a static corner-only teaser that appears once brulee
   settles and never itself becomes hero -- see the concept file
   daily-ritual-v5-concept.html for the full design rationale (fade-vs-hard-cut
   corner reveal timing, why honey doesn't get its own scrub turn, etc). GSAP +
   ScrollTrigger are already loaded globally near the end of the page (used by
   several other sections), so no extra script tags are needed here. */
var rzWrap=document.getElementById('rz-wrap');
if(!rzWrap)return;
var rzCards=[].slice.call(document.getElementById('rz-cards').querySelectorAll('.rz-card'));
if(!rzCards.length)return;
var rzCardInners=rzCards.map(function(c){return c.querySelector('.rz-card-inner');});
var rzCapEl=document.getElementById('rz-cap-hero'),rzIndexEl=document.getElementById('rz-index'),rzHeroSlot=document.getElementById('rz-slot-hero'),rzCornerSlot=document.getElementById('rz-slot-corner');
var rzCapInner=document.createElement('div');
rzCapInner.className='rz-cap-inner';
rzCapEl.appendChild(rzCapInner);

var RZ_N_CYCLE=3; // only coffee/carrots/brulee take a turn as hero -- honey (index 3) is corner-only, see below
function rzRenderCaption(i){
var c=rzCards[i];
rzCapInner.innerHTML='<p class="rz-cap-eye">'+c.getAttribute('data-eye')+'</p><p class="rz-cap-body">'+c.getAttribute('data-body')+'</p>';
}
rzRenderCaption(0);
rzIndexEl.textContent='01 / 0'+RZ_N_CYCLE;

function rzClamp01(v){return Math.max(0,Math.min(1,v));}
function rzShorted(v,mult){return Math.min(v*mult,1);} // Joby's own "shorted-progress" acceleration trick
var RZ_SEG=1/RZ_N_CYCLE,RZ_TRANS_FRAC=0.55,RZ_TW=RZ_SEG*RZ_TRANS_FRAC,RZ_SETTLE=0.70;

var rzRects={hero:null,corner:null};
function rzMeasure(){
var stage=rzWrap.querySelector('.rz-stage');
var stageRect=stage.getBoundingClientRect();
var hr=rzHeroSlot.getBoundingClientRect(),cr=rzCornerSlot.getBoundingClientRect();
rzRects.hero={left:hr.left-stageRect.left,top:hr.top-stageRect.top,width:hr.width,height:hr.height};
rzRects.corner={left:cr.left-stageRect.left,top:cr.top-stageRect.top,width:cr.width,height:cr.height};
}
rzMeasure();
window.addEventListener('resize',rzMeasure);
function rzLerp(a,b,t){return a+(b-a)*t;}

var rzLastHero=0;
function rzRender(progress){
var p=rzClamp01(progress);
for(var i=0;i<rzCards.length;i++){
var el=rzCards[i];
var box,opacity;
if(i<RZ_N_CYCLE){
var reignStart=i*RZ_SEG,reignEnd=(i+1)*RZ_SEG;
var boundaryIn=reignStart,boundaryOut=reignEnd;
box={left:rzRects.hero.left,top:rzRects.hero.top,width:rzRects.hero.width,height:rzRects.hero.height};
opacity=1;
if(i===0){
opacity=1;
}else{
var winStart=boundaryIn-RZ_TW/2;
var raw=rzClamp01((p-winStart)/RZ_TW);
var t=rzShorted(raw,1.7);
box={left:rzLerp(rzRects.corner.left,rzRects.hero.left,t),top:rzLerp(rzRects.corner.top,rzRects.hero.top,t),width:rzLerp(rzRects.corner.width,rzRects.hero.width,t),height:rzLerp(rzRects.corner.height,rzRects.hero.height,t)};
var visibleFrom=(i===1)?0:((i-1)*RZ_SEG-RZ_TW/2+RZ_SETTLE*RZ_TW);
opacity=(p<visibleFrom)?0:1;
}
if(i<RZ_N_CYCLE-1){
var winStart2=boundaryOut-RZ_TW/2;
if(p>winStart2){
var raw2=rzClamp01((p-winStart2)/RZ_TW);
var t2=rzShorted(raw2,1.7);
opacity=opacity*(1-t2);
}
}
}else{
box={left:rzRects.corner.left,top:rzRects.corner.top,width:rzRects.corner.width,height:rzRects.corner.height};
var visibleFromH=(RZ_N_CYCLE-1)*RZ_SEG-RZ_TW/2+RZ_SETTLE*RZ_TW;
opacity=(p<visibleFromH)?0:1;
}
el.style.left=box.left.toFixed(1)+'px';
el.style.top=box.top.toFixed(1)+'px';
el.style.width=box.width.toFixed(1)+'px';
el.style.height=box.height.toFixed(1)+'px';
el.style.opacity=opacity.toFixed(3);
}
var heroIdx=Math.min(RZ_N_CYCLE-1,Math.floor(p*RZ_N_CYCLE+1e-6));
var capOpacity=1;
for(var k=1;k<RZ_N_CYCLE;k++){
var b=k*RZ_SEG,ws=b-RZ_TW/2,we=b+RZ_TW/2;
if(p>=ws&&p<=we){
var lp=rzClamp01((p-ws)/RZ_TW);
capOpacity=lp<0.5?1-rzShorted(lp*2,1.7):rzShorted((lp-0.5)*2,1.7);
}
}
rzCapInner.style.opacity=capOpacity.toFixed(3);
if(heroIdx!==rzLastHero){rzLastHero=heroIdx;rzRenderCaption(heroIdx);rzIndexEl.textContent=String(heroIdx+1).padStart(2,'0')+' / 0'+RZ_N_CYCLE;}
}
rzRender(0);
// static fallback if GSAP/ScrollTrigger somehow didn't load -- frame-0 layout
// (coffee as hero) still renders correctly above, just without the scrub,
// matching the same graceful-degradation pattern used elsewhere on this page.
if(!window.gsap||!window.ScrollTrigger)return;

var rzAnimateIn=0;
function rzUpdateZoom(){
var scale=(1.15-rzAnimateIn*0.15).toFixed(4);
rzCardInners.forEach(function(inner){inner.style.transform='scale('+scale+')';});
}
rzUpdateZoom();

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.create({
trigger:'#rz-wrap',
start:'top top',
end:function(){return '+='+(window.innerHeight*RZ_N_CYCLE*1.15);},
pin:'#rz-pin',
scrub:0.4,
onUpdate:function(self){rzRender(self.progress);},
onRefresh:rzMeasure
});
var rzEnterP=0,rzExitP=0;
function rzRecomputeZoom(){rzAnimateIn=Math.min(rzEnterP,1-rzExitP);rzUpdateZoom();}
ScrollTrigger.create({trigger:'#rz-wrap',start:'top bottom',end:'top top',scrub:true,onUpdate:function(self){rzEnterP=self.progress;rzRecomputeZoom();}});
ScrollTrigger.create({trigger:'#rz-wrap',start:'bottom bottom',end:'bottom top',scrub:true,onUpdate:function(self){rzExitP=self.progress;rzRecomputeZoom();}});
}catch(e){}})();